import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Home: React.FC = () => {
  return (
    <div>
      {/* Hero Section */}
      <div 
        className="d-flex align-items-center text-white text-center position-relative"
        style={{
          backgroundImage: `linear-gradient(rgba(20, 52, 103, 0.7), rgba(20, 52, 103, 0.7)), url('/assets/images/PXL_20250329_004724355.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          minHeight: '80vh'
        }}
      >
        <Container>
          <h1 className="display-2 fw-bold mb-4">Development Over Trophies.</h1>
          <p className="lead mb-5 fs-3">Making higher level soccer available to more Central Iowa kids.</p>
          <div className="d-flex justify-content-center gap-3">
            <Link to="/academy" className="btn btn-primary btn-lg text-white fw-bold px-4">Academy (U9-U10)</Link>
            <Link to="/select" className="btn btn-light text-navy fw-bold btn-lg px-4">Select (U11+)</Link>
          </div>
        </Container>
      </div>

      {/* 2026-27 Season Announcement */}
      <div className="bg-teal text-white py-3">
        <Container className="text-center">
          <p className="mb-2 fw-bold fs-5">
            Now accepting players for the 2026-27 season!
          </p>
          <p className="mb-3 small">
            Submitting interest is the first step toward joining the 515 family for the fall.
          </p>
          <div className="d-flex justify-content-center gap-2 flex-wrap">
            <Link to="/select" className="btn btn-light text-navy fw-bold">
              Select Interest (U11+)
            </Link>
            <Link to="/registration" className="btn btn-outline-light fw-bold">
              All Registration Options
            </Link>
          </div>
        </Container>
      </div>

      {/* Philosophy/Mission Section */}
      <Container className="py-5">
        <Row className="justify-content-center text-center mb-5">
          <Col md={10} lg={8}>
            <h2 className="text-navy fw-bold mb-4">Our Mission</h2>
            <p className="lead text-muted">
              515 Soccer Academy was born from a desire to reduce the stress of traditional tryouts and focus on what matters: <strong>Development</strong>.
              We believe talent is built through hard work, not just discovered.
            </p>
          </Col>
        </Row>

        <Row className="g-4">
          <Col md={6}>
            <Card className="h-100 border-0 shadow-sm hover-shadow transition-all">
              <Card.Body className="p-4">
                <div className="text-center mb-3">
                    <span className="display-4 text-teal">NO</span>
                </div>
                <h3 className="text-center fw-bold mb-3">Tryouts</h3>
                <Card.Text className="text-center">
                  We believe that a short tryout session is an inaccurate way to assess a young player's potential. 
                  Instead, we have a proven track record of fielding highly competitive teams by focusing on long-term development rather than recruitment.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6}>
            <Card className="h-100 border-0 shadow-sm">
              <Card.Body className="p-4">
                <div className="text-center mb-3">
                    <span className="display-4 text-teal">YES</span>
                </div>
                <h3 className="text-center fw-bold mb-3">Development</h3>
                <Card.Text className="text-center">
                  We focus on long-term growth over short-term wins. Our "Growth Mindset" philosophy encourages players to take risks, learn from mistakes, and improve every day.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* The Story Section */}
      <div className="bg-light py-5">
        <Container>
          <Row className="align-items-center">
             <Col md={6}>
                 <img src="/assets/images/PXL_20251102_221207810.jpg" alt="Team with Medals" className="img-fluid rounded shadow" />
             </Col>
             <Col md={6} className="mt-4 mt-md-0">
                <h3 className="fw-bold text-navy mb-3">Proof in the Process</h3>
                <p>
                    <strong>We don't need tryouts to win.</strong> We need time, patience, and hard work.
                </p>
                <p>
                    In 2012, one of our founding teams lost their first game 10-0. Two months later, they lost to that same team 6-2. 
                    By the following Spring, they won 3-1. That same group went on to compete at higher levels and find lasting success.
                </p>
                <p>
                    This is why we ask our families to have the courage to weather the "growing pains." 
                    When you focus on the player instead of the trophy, the trophies eventually come anyway.
                </p>
                <Link to="/about" className="btn btn-outline-primary">Read More About Us</Link>
             </Col>
          </Row>
        </Container>
      </div>

      {/* Latest News / Facebook Feed */}
      <Container className="py-5">
        <h2 className="text-center fw-bold text-navy mb-5">Latest News</h2>
        <Row className="justify-content-center">
            <Col md={8} lg={6}>
                <div className="bg-white rounded shadow-sm overflow-hidden d-flex justify-content-center py-3 border">
                    <iframe 
                        src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2F515SoccerAcademy&tabs=timeline&width=500&height=600&small_header=false&adapt_container_width=true&hide_cover=true&show_facepile=true&appId" 
                        width="500" 
                        height="600" 
                        style={{border: 'none', overflow: 'hidden'}} 
                        scrolling="no" 
                        frameBorder="0" 
                        allowFullScreen={true} 
                        allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                        title="515 Soccer Academy Facebook Feed"
                    ></iframe>
                </div>
            </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Home;
